 <template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-format-list-checkbox"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1">
        <v-col cols="8" class="px-0">
          <v-row class="mx-3">
            <v-col cols="12" class="content_category rounded-lg">
              <v-row class="pa-2">
                <v-col cols="6">
                  <v-select
                      background-color="#EDF2F7"
                      filled
                      v-model="category.brand_id"
                      :items="brands"
                      item-text="name"
                      item-value="id"
                      label="Chọn nhãn hàng"
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      label="Tên"
                      v-model="category.name"
                      placeholder="Nhập tên category"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                      background-color="#EDF2F7"
                      filled
                      rows="2"
                      label="Mô tả ngắn"
                      v-model="category.short_description"
                      placeholder="Nhập mô tả ngắn"
                  ></v-textarea>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      label="Tên gợi nhớ"
                      v-model="category.reminiscent_name"
                      placeholder="Nhập tên gợi nhớ"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      label="Slug"
                      v-model="category.slug"
                      placeholder="Nhập tên slug"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      label="Số lượng sản phẩm hiển thị trên 1 hàng"
                      v-model="config.number_product_on_row"
                      placeholder="Số lượng sản phẩm hiển thị trên 1 hàng"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      label="Số lượng sản phẩm hiển thị trên 1 hàng Mobile"
                      v-model="config.number_product_on_row_mobile"
                      placeholder="Số lượng sản phẩm hiển thị trên 1 hàng Mobile"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-select
                      background-color="#EDF2F7"
                      filled
                      v-model="config.view_type"
                      :items="view_types"
                      item-text="value"
                      item-value="key"
                      label="Chọn kiểu hiển thị"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <ck-content class="ck-categry" :content="category.description" @getData="value => category.description = value"/>

                </v-col>
                <v-col cols="4">
                  <v-file-input
                      label="Ảnh banner desktop"
                      placeholder="Tải ảnh lên"
                      prepend-icon="mdi-camera"
                      @change="fileBannerDesktop"
                  ></v-file-input>
                  <v-img
                      :src="src_banner_desktop"
                  ></v-img>
                  <v-text-field v-if="src_banner_desktop"
                      background-color="#EDF2F7"
                      filled
                      label="Alt ảnh banner desktop"
                      v-model="category.banner_media.alt_image"
                      placeholder="Nhập alt"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-file-input
                      label="Ảnh banner mobile"
                      placeholder="Tải ảnh lên"
                      prepend-icon="mdi-camera"
                      @change="fileBannerMobile"
                  ></v-file-input>
                  <v-img
                      :src="src_banner_mobile"
                  ></v-img>
                  <v-text-field v-if="src_banner_mobile"
                      background-color="#EDF2F7"
                      filled
                      label="Alt ảnh banner mobile"
                      v-model="category.banner_mobile_media.alt_image"
                      placeholder="Nhập alt"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-file-input
                      label="Ảnh đại diện"
                      placeholder="Tải ảnh lên"
                      prepend-icon="mdi-camera"
                      @change="fileSelected"
                  ></v-file-input>
                  <v-img
                      :src="src"
                  ></v-img>
                  <v-text-field v-if="src"
                      background-color="#EDF2F7"
                      filled
                      label="Alt ảnh đại diện"
                      v-model="category.main_media.alt_image"
                      placeholder="Nhập alt"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                      background-color="#EDF2F7"
                      filled
                      :items="category_parents"
                      item-text="name"
                      item-value="id"
                      v-model="category.parent_id"
                      label="Danh mục cha"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" class="set-height-cols multi-select">
                  <v-autocomplete
                      background-color="#EDF2F7"
                      filled
                      item-value="id"
                      item-text="name"
                      clearable
                      :items="posts"
                      v-model="category.post_ids"
                      label="Bài viết liên quan"
                      multiple
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                      v-model="category.is_group_template"
                      label="Là nhóm thông số kỹ thuật"
                      color="primary"
                      :value="category.is_group_template"
                      hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                      v-model="category.is_comparable"
                      label="Là nhóm có thể so sánh"
                      color="primary"
                      :value="category.is_comparable"
                      hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="content_category mt-3 rounded-lg">
              <v-row class="mx-3">
                <v-col cols="3" class="d-flex mt-5 pa-0 pb-2">
                  <h4>SEO</h4>
                </v-col>
                <v-col cols="12" class="pa-0">
                    <v-text-field
                      background-color="#EDF2F7"
                      filled
                      @blur="triggerSeo"
                      label="SEO Title"
                      placeholder="Nhập SEO Title"
                      v-model="category.meta_title"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" class="pa-0 pb-2">
                    <v-textarea
                      class="content-textarea"
                      background-color="#EDF2F7"
                      filled
                        @blur="triggerSeo"
                      label="SEO Description"
                      placeholder="Nhập mô tả"
                      v-model="category.meta_description"
                    >
                    </v-textarea>
                </v-col>
              </v-row>
            </v-col>

            <seo 
              @getKeywords="getKeywords"
              :trigger_seo="count_trigger_seo"
              :text_seo="text_seo"
              :keywords="category.meta_keyword"
              :meta_title="category.meta_title"
              :content="category.description"
              :slug="category.slug"
              :meta_description="category.meta_description"
              :col="12"
            />
            <v-col cols="12" class="text-center">
              <v-btn
                  color="primary"
                  width="180"
                  @click="save_category()"
              >
                Lưu
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="3" class="content_category rounded-lg ml-3">
          <div class="mx-2" style="width: 90%">
            <v-row>
              <v-col cols="8">
                <h4 class="mb-1">Thông số kỹ thuật</h4>
              </v-col>
              <v-col cols="4">
                <v-btn
                    class="d-flex justify-end"
                    color="primary"
                    @click="addBlock()"
                >
                  ADD
                </v-btn>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <div v-for="(i, index) in category.list_attribute" :key="index">
              <v-text-field
                  v-model="i.name"
                  outlined
                  dense
                  append-icon="mdi-delete"
                  @click:append="clearBlock(i, index)"
              ></v-text-field>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import {GET_LIST_NEWS_SEARCH} from '@/store/modules/news'
import {GET_LIST_CATEGORY, UPDATE_CATEGORY, UPLOAD_CATEGORY_IMAGE,GET_DETAIL_CATEGORY} from '@/store/modules/category'
import {GET_LIST_BRAND} from '@/store/modules/brand'
// import {UPLOAD} from '@/store/modules/upload'
import {mapGetters} from 'vuex'
import CkContent from "@/components/ck-content"
import Seo from "@/components/seo"
import { replaceCkContent } from '@/utils/helpers'
export default {
  components:{
    CkContent,
    Seo
  },
  data() {
    return {
      text_seo: "",
      SEO: [],
      count_trigger_seo: 0,
      list_imgs: [],
      src:'',
      src_banner_desktop:'',
      src_banner_mobile:'',
      image: {},
      hasImage: false,
      selectedFile:null,
      block:{
        name:'',
        count:0
      },
      view_types: [
        {
          key: 0,
          value: "Dạng Grid"
        },
        {
          key: 1,
          value: "Dạng Line"
        }
      ],
      page: "Quản lý category",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true
        },
        {
          text: "Quản lý sản phẩm",
          disabled: true,
        },
        {
          text: "Quản lý category",
          disabled: true,
        },
        {
          text: "Thêm category",
          disabled: true,
        },
      ],
      config: {
        view_type: 0,
        number_product_on_row: 4,
        number_product_on_row_mobile: 2,
      }

    };
  },
  computed:{
    ...mapGetters({
      posts: "newSearches",
      category_parents: "categories",
      brands: "brands",
      category: "categoryDetail",
      seos: "seos",
    })
  },
  async created(){
    await this.$store.dispatch(`${GET_LIST_NEWS_SEARCH}`);
    await this.$store.dispatch(`${GET_LIST_CATEGORY}`);
    await this.$store.dispatch(`${GET_DETAIL_CATEGORY}`, this.$route.params.id);
    await this.$store.dispatch(`${GET_LIST_BRAND}`);
    if (this.category && this.category.SEO) {
      this.category.SEO.forEach((el) => {
        this.SEO.push(el.id);
      });
    }
    if (this.category && this.category.config) {
      this.config = this.category.config
    }
  },
  watch:{
    category(val){
      // const _this = this;
      let defaultData = {
        url:"",
        alt_image: "",
      };
      if(val && val.main_media){
        this.src = val.main_media.path
      }
      if(val && val.banner_media){
        this.src_banner_desktop = val.banner_media.path
      }
      if(val && val.banner_mobile_media){
        this.src_banner_mobile = val.banner_mobile_media.path
      }
      this.category.main_media = val.main_media ?? defaultData;
      this.category.banner_media = val.banner_media ?? defaultData;
      this.category.banner_mobile_media = val.banner_mobile_media ?? defaultData;
    },
  },
  methods:{
    addBlock() {
      this.category.list_attribute.push({
        name: this.block.name,
        // count: this.block.count++,
      })
      this.$forceUpdate()
    },
    clearBlock(i, index){
      this.category.list_attribute.splice(index, 1)
      this.$forceUpdate()
    },
    fileSelected(event) {
      const _this = this;
      if (!event) {
        // this.category.main_media = {};
        console.log(123)
      } else {
        this.src = ''
        this.category.main_media = {};
        this.image = event;
        this.src = URL.createObjectURL(this.image);
        let formData = new FormData();
        formData.append("upload", this.image);
        formData.append("type", "categories");
        this.$store.dispatch(`${UPLOAD_CATEGORY_IMAGE}`, formData).then((data) => {
          if (data && data.data && data.data.data) {
            data.data.data.forEach(element => {
              let data = {
                id:element.media_id,
                url:element.path,
                alt_image: "",
              }
              _this.category.main_media = data
            })
          }
        })
      }
    },

    //banner desktop
    fileBannerDesktop(event) {
      const _this = this;
      if (!event) {
        // this.src_banner_desktop = '';
        // this.category.banner_media = {};
      } else {
        this.src_banner_desktop = ''
        this.category.banner_media = {};
        this.image = event;
        this.src_banner_desktop = URL.createObjectURL(this.image);
                console.log("destop",this.src_banner_desktop )

        let formData = new FormData();
        formData.append("upload", this.image);
        formData.append("type", "categories");
        this.$store.dispatch(`${UPLOAD_CATEGORY_IMAGE}`, formData).then((data) => {
          if (data && data.data && data.data.data) {
            data.data.data.forEach(element => {
              let data = {
                id:element.media_id,
                url:element.path,
                alt_image: "",
              }
              _this.category.banner_media = data
            })
          }
        })
      }
    },
    //banner mobile
    fileBannerMobile(event) {
      const _this = this;
      if (!event) {
        // this.src_banner_mobile = '';
        // this.category.banner_mobile_media = {};
      } else {
        this.src_banner_mobile = ''
        this.category.banner_mobile_media = {};
        this.image = event;
        this.src_banner_mobile=URL.createObjectURL(this.image);
         console.log("destop",this.src_banner_mobile)
        let formData = new FormData();
        formData.append("upload", this.image);
        formData.append("type", "categories");
        this.$store.dispatch(`${UPLOAD_CATEGORY_IMAGE}`, formData).then((data) => {
          if (data && data.data && data.data.data) {
            data.data.data.forEach(element => {
              let data = {
                id:element.media_id,
                url:element.path,
                alt_image: "",
              }
              _this.category.banner_mobile_media = data
            })
          }
        })
      }
    },

    save_category(){
      let data_category = {
        id:this.category.id,
        short_description:this.category.short_description,
        reminiscent_name:this.category.reminiscent_name,
        name:this.category.name,
        parent_id:this.category.parent_id,
        brand_id:this.category.brand_id,
        description:replaceCkContent(this.category.description),
        slug:this.category.slug,
        main_media:JSON.stringify(this.category.main_media),
        banner_media:JSON.stringify(this.category.banner_media),
        banner_mobile_media:JSON.stringify(this.category.banner_mobile_media),
        list_attribute:JSON.stringify(this.category.list_attribute),
        is_group_template:this.category.is_group_template,
        is_comparable:this.category.is_comparable,
        config:this.config,
        post_ids:this.category.post_ids,
        meta_title: this.category.meta_title,
        meta_description: this.category.meta_description,
        meta_keyword: this.category.meta_keyword,
      }
      this.$store.dispatch(`${UPDATE_CATEGORY}`, data_category).then((data)=>{
        if (data.data.status==1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          this.$router.push('/manage_productions/Manage_category')
        }else{
          alert(data.data.errors)
        }
      });
    },
    triggerSeo(){
      this.count_trigger_seo++;
    },
    getKeywords(keywords){
      this.category.meta_keyword = keywords
    }
  }
};
</script>
<style lang="scss">
.content_category {
  background: #ffffff !important;
.content-textarea .v-input__control {
  height: 165px!important;
}
}
.ck-categry .ck-editor__main .ck-content {
  height: 40px;
}
</style>